import { createRef, useEffect, useRef, useState } from 'react'
import { togglePersonFlag } from '@/store/general'
import { apiObj, commonObj } from '@/common/common'
import { Popconfirm, message, Button } from 'antd'
import { CloseCircleTwoTone } from '@ant-design/icons'
import SheetModal from './sheetModal'
import SongModal from './songModal'
// import ColorThief from "colorthief"
import List from './list'
import Lrc from './lrc'
import Audio from './audio'
import styles from '../css/person.modules.less'

/**
 * 歌曲切换后面看看能不能改为useContext的方式来试试，通过ref来传有点儿繁琐了
 */
const Person = () => {
  const baseUrl = commonObj.staticBaseUrl
  const [sheetList, setSheetList] = useState([])
  const [currentSheet, setCurrentSheet] = useState([]) // 歌单列表
  // const [songList, setSongList] = useState([]) // 歌曲列表
  const [actionFlag, setActionFlag] = useState(false) // 弹框标题
  const [actionType, setActionType] = useState('') // 操作类型
  const [isPlaying, setIsPlaying] = useState(false) // 播放状态
  const [messageApi, content] = message.useMessage()
  const playType = useRef(1) // 歌曲播放方式 1列表循环（默认）2单曲循环 3随机播放
  const playList = useRef() // 正在播放的歌曲列表
  const songList = useRef([]) // 歌曲列表
  const cSheet = useRef({}) // 当前歌单
  const personRef = useRef()
  const maskRef = useRef()
  const sheetRef = useRef() // 歌单列表
  const contentRef = useRef() // 下方内容
  const obHeight = useRef() // 观察器
  const listRef = useRef()
  const lrcRef = useRef()
  const audioRef = useRef()
  const sheetModalRef = createRef()
  const songModalRef = createRef()

  /**
   * @description 监听键盘空格按键
   * @description 监听sheetBox高度并设置下方content的高度
   */
  useEffect(() => {
    document.addEventListener('keydown', handleKeydown)
    getSheetList()
    if (sheetRef.current) {
      obHeight.current = new ResizeObserver(e => {
        const h = e[0].target.clientHeight
        contentRef.current.style.height = `calc(100% - 30px - ${h}px)`
      })
      obHeight.current.observe(sheetRef.current)
    }
    return () => {
      document.removeEventListener('keydown', handleKeydown)
      obHeight.current.disconnect()
    }
  }, [])
  // 监听鼠标按键
  const handleKeydown = e => {
    if (!songList.current?.length) {
      messageApi.warning('暂无歌曲可以播放')
      return
    }
    if (e.key === ' ' && !playList.current?.length) {
      playSong(songList.current[0], 'list')
    } else if (e.key === ' ' && playList.current.length) {
      if (audioRef.current.getPlayStatus()) {
        audioRef.current.setPlayStatus(false)
      } else {
        audioRef.current.setPlayStatus(true)
      }
    }
  }
  // 获取歌单列表
  const getSheetList = () => {
    fetch(`${apiObj.url}/sheet/sheetList`)
      .then(res => res.json())
      .then(res => {
        setSheetList(res.data.list)
        sheetChange(res.data.list[0])
      })
  }
  // 获取歌曲列表
  const getSongList = val => {
    let sheetId = val?.sheetId || cSheet.current.sheetId
    fetch(`${apiObj.url}/song/songList?sheetId=${sheetId}`)
      .then(res => res.json())
      .then(res => {
        // setSongList(res.data.list)
        songList.current = res.data.list
        listRef.current.getSongList(res.data.list)
      })
  }
  // 获取并设置背景
  const getThiefColor = val => {
    // const color = new ColorThief()
    // const img = new Image()
    // img.src = val
    // img.crossOrigin = ""
    // img.onload = () => {
    //   let num = 3 // 获取的颜色块儿的数量
    //   let str = ""
    //   let arr = color.getPalette(img, num)
    //   // console.log(arr)
    //   for (let i = 0; i < num; i++) {
    //     str += `,rgb(${arr[i].join(",")})`
    //   }
    //   // 渐变的背景色切换是不支持过度的，其他的可以
    //   personRef.current.style.background = `linear-gradient(to top left${str})`
    // }
    personRef.current.style.background = 'gray'
    maskRef.current.style.backgroundImage = `url(${val})`
  }
  // 歌单切换
  const sheetChange = val => {
    setCurrentSheet(val)
    cSheet.current = val
    getSongList(val)
  }
  // 右击事件
  const rightClick = (e, val) => {
    e.preventDefault()
    if (actionFlag) {
      sheetModalRef.current.show('edit', val)
    }
  }
  // 设置播放方式
  const setPlayMusicType = val => {
    playType.current = val
  }
  // 处理播放状态变化
  const handlePlayStatusChange = status => {
    setIsPlaying(status)
  }
  // 播放歌曲
  const playSong = (val, str) => {
    if (str) playList.current = songList.current // 如果有str存在表示在列表上点击了歌曲播放而不是自动切换的那种，所以要把正在播放的列表给更新一下
    let a = ''
    if (playList.current.length === 1) a = 'one'
    // 给图片添加时间戳防止缓存导致canvas读取图片地址跨域问题，使用encodeURI进行编码是因为有些文件名字带有空格
    let url =
      baseUrl + val.sheetName + '/' + encodeURI(val.cover) + '?timestamp=' + new Date().getTime()
    // console.log(url)
    getThiefColor(url)
    lrcRef.current.setCoverUrl(val)
    audioRef.current.setMusicUrl(val, a)
  }
  /**
   * @description 切换歌曲
   * @param {String} val 切换歌曲的url
   * @param {Number} type 1或者-1代表上一首与下一首
   * @tips 放在父组件进行歌曲切换是因为要切换歌词，歌曲，cover等，一起操作好点
   */
  const changeSong = (val, type) => {
    const index = playList.current.findIndex(item => item.songName === val.songName)
    let l = 0
    if (playType.current === 1) {
      // 列表循环
      const len = playList.current.length
      switch (type) {
        case -1:
          if (index === 0) l = len - 1
          else l = index - 1
          break
        case 1:
          if (index === len - 1) l = 0
          else l = index + 1
          break
        default:
          break
      }
    } else if (playType.current === 3) {
      // 随机播放（只有一首歌随机播放的情况已经在audio组件里面处理过了）
      let newIndex = Math.floor(Math.random() * playList.current.length)
      // 如果随机到的索引与当前索引相同，则重新随机
      while (newIndex === index) {
        newIndex = Math.floor(Math.random() * playList.current.length)
      }
      l = newIndex
      // console.log('随机播放索引', l)
    } else if (playType.current === 2) {
      // 单曲循环在audio的组件中做了处理，这里不管}
    }
    playSong(playList.current[l])
    listRef.current.setCurrentSong(playList.current[l])
  }
  // 处理音频时间更新，同步更新歌词高亮
  const handleTimeUpdate = currentTime => {
    if (lrcRef.current) {
      lrcRef.current.updateCurrentTime(currentTime)
    }
  }
  // 操作歌单
  const actionSheet = val => {
    if (val === 'add') {
      sheetModalRef.current.show('add')
    } else if (val === 'edit') {
      setActionFlag(true)
      setActionType(val)
    } else if (val === 'cancel') {
      setActionFlag(false)
      setActionType(val)
    }
  }
  // 删除歌单
  const deleteSheet = (e, val) => {
    console.log('删除歌单', e)
    console.log('删除歌单', val)
    // 阻止冒泡
    e.stopPropagation()
  }
  // 删除确认
  const deleteConfirm = (e, val) => {
    console.log('要删除的歌单', val)
    e.stopPropagation()
    if (val.sheetId === cSheet.current.sheetId) {
      messageApi.warning('请先切换到其他歌单在删除此歌单！')
      return
    }
    // 阻止冒泡
    fetch(`${apiObj.url}/sheet/delete?sheetId=${val.sheetId}`)
      .then(res => res.json())
      .then(res => {
        if (res.code !== 200) {
          messageApi.error(res.data.msg)
          return
        }
        messageApi.success('操作成功！')
        setSheetList(sheetList.filter(item => item.sheetId !== val.sheetId))
        // getSheetList()
      })
  }
  // 取消
  const cancel = e => {
    console.log('取消')
    // 阻止冒泡
    e.stopPropagation()
  }
  // 新增歌曲
  const addSong = () => {
    console.log('添加歌曲')
    songModalRef.current.show(cSheet.current)
  }
  return (
    <>
      {content}
      <div className={styles.personBox} ref={personRef}>
        <div onClick={togglePersonFlag}>
          <span className="go_home">My music</span>
        </div>
        <Button type="primary" className="add_song" onClick={addSong}>
          添加歌曲
        </Button>
        <div className="box">
          <div className="mask" ref={maskRef}></div>
          <div className="wrap">
            <ul className="sheet_box" ref={sheetRef}>
              {sheetList.map(item => (
                <li
                  key={item.sheetId}
                  onClick={() => sheetChange(item)}
                  onContextMenu={e => rightClick(e, item)}
                  className={`${actionFlag && 'actioning'} ${
                    item === currentSheet && 'active_sheet'
                  }`}
                >
                  {item.sheetName}
                  {/* {actionFlag && <CloseCircleFilled className="delete" />} */}
                  {actionFlag && (
                    <Popconfirm
                      title="删除歌单"
                      description={`是否确认删除${item.sheetName}歌单？`}
                      onConfirm={e => deleteConfirm(e, item)}
                      onCancel={e => cancel(e, item)}
                      okText="是"
                      cancelText="否"
                    >
                      <CloseCircleTwoTone
                        twoToneColor="red"
                        className="delete"
                        onClick={e => deleteSheet(e, item)}
                      />
                    </Popconfirm>
                  )}
                </li>
              ))}
              <div className="action">
                <span className="add" onClick={() => actionSheet('add')}>
                  新增
                </span>
                {actionType !== 'edit' ? (
                  <span className="edit" onClick={() => actionSheet('edit')}>
                    编辑
                  </span>
                ) : (
                  <span className="edit" onClick={() => actionSheet('cancel')}>
                    取消
                  </span>
                )}
              </div>
            </ul>
            <div className="content" ref={contentRef}>
              <List ref={listRef} setPlaySong={playSong} refreshList={getSongList} />
              <Lrc ref={lrcRef} isPlaying={isPlaying} />
              <Audio
                ref={audioRef}
                handleKeydown={handleKeydown}
                setChangeSong={changeSong}
                setPlayMusicType={setPlayMusicType}
                onTimeUpdate={handleTimeUpdate}
                onPlayStatusChange={handlePlayStatusChange}
              />
            </div>
          </div>
        </div>
        <SheetModal ref={sheetModalRef} refreshList={getSheetList} />
        <SongModal ref={songModalRef} refreshList={getSongList} />
      </div>
    </>
  )
}

export default Person
